<div class="login-page t-center">
  <section class="login-header">
    @let header = pageContents[pageContentSelected()];
    <div class="login-header-text text-center">
      <h1 class="font-bold m-0">{{header.title}}</h1>
      <h3 class="font-light m-0" [innerHTML]="header.text"></h3>
    </div>
    <div class="curve">

    </div>
    <img class="cloudigo-graphic" [src]="header.image" [alt]="header.image_alt"/>
  </section>

  @switch(state()){
    @case ('request'){
      <!-- Enter your Phone Number -->
      <auth-request [phone]="phone" (response)="onWaitingForVerification($event)"/>
    }
    @case ('verify'){
      <!-- Enter verification code from SMS -->
      <auth-verify [phone]="phone??undefined" (login)="onVerified($event)" (state)="onVerifyStateChange($event)"/>
    }
    @case ('register'){
      <!-- Register for cloudigo -->
      <auth-register [auth_id]="auth_id??undefined" (state)="onRegisterStateChange($event)" (login)="onRegistered($event)"/>
    }
  }
</div>
